import { getCookie } from '@client/helpers/cookie';
import { get } from '@client/lib/request';
import { PERSONALIZED_CAMPAIGNS_FIELDS } from '@shared/constants';
import { MyLoungeResponse } from '@shared/types/mylounge';

const getUpcomingLimit = (): number | null => {
    const EXTENDED_UPCOMING_COOKIES = 'zl_extended_upcoming';

    return getCookie(EXTENDED_UPCOMING_COOKIES) === 'true' ? 200 : null;
};

export const getCampaigns = (onlineAt: string): Promise<MyLoungeResponse | null> => {
    return get(
        '/api/phoenix/mylounge/campaigns',
        { online_at: onlineAt, upcoming_limit: getUpcomingLimit() },
        null,
        true,
    );
};

export const getPersonalizedCampaigns = ({
    allowEligiblePlusAccess,
}: {
    allowEligiblePlusAccess?: boolean;
} = {}): Promise<MyLoungeResponse | null> => {
    return get(
        '/api/phoenix/mylounge/personalized-campaigns',
        {
            fields: PERSONALIZED_CAMPAIGNS_FIELDS,
            upcoming_limit: getUpcomingLimit(),
            plus_early_access_supported: true,
            allow_eligible_plus_access: allowEligiblePlusAccess,
        },
        null,
        true,
    );
};
